export default __webpack_public_path__ + "static/media/Kuka.5d4d8eda.png";